import { cva } from 'class-variance-authority';

/**
 * Base UserProfile container styles
 */
export const baseUserProfileStyles = [
  'flex',
  'flex-col',
  'gap-8',
  'p-6',
  'bg-semantic-globals-page-content-background',
  'rounded-lg',
  'w-full',
].join(' ');

/**
 * UserProfile variants using class-variance-authority
 */
export const userProfileVariants = cva(baseUserProfileStyles, {
  variants: {},
  defaultVariants: {},
});


